module.exports = __webpack_public_path__ + "img/companyInfoBanner.7a0b5885.png";